// accepts a list of step configs and build a tree of step configs
export function buildStepConfigTree(stepConfigs) {
    var _a;
    var stepMap = new Map();
    // build the map first
    for (var _i = 0, stepConfigs_1 = stepConfigs; _i < stepConfigs_1.length; _i++) {
        var stepConfig = stepConfigs_1[_i];
        var stepConfigNode = {
            config: stepConfig,
            stepInstances: []
        };
        stepMap.set(stepConfig.name, stepConfigNode);
    }
    // add the parent to the config nodes
    for (var _b = 0, stepConfigs_2 = stepConfigs; _b < stepConfigs_2.length; _b++) {
        var stepConfig = stepConfigs_2[_b];
        if ((_a = stepConfig.needs) === null || _a === void 0 ? void 0 : _a.name) {
            var currentNode = stepMap.get(stepConfig.name);
            if (currentNode === undefined) {
                throw new Error("Could not find node for step ".concat(stepConfig.name));
            }
            var parentNode = stepMap.get(stepConfig.needs.name);
            if (parentNode) {
                currentNode.parent = parentNode;
            }
        }
    }
    return stepMap;
}
//# sourceMappingURL=buildStepConfigTree.js.map